import { render, staticRenderFns } from "./NumberCounter.vue?vue&type=template&id=924fb7d6"
import script from "./NumberCounter.vue?vue&type=script&lang=js"
export * from "./NumberCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports